<button
  id="close-footbar"
  type="button"
  class="close"
  aria-label="Close"
  [mat-dialog-close]="false">
  <span aria-hidden="true">×</span>
</button>
<h2 mat-dialog-title>{{ 'k002583' | translate }}</h2>
<ng-container *ngIf="isLoaded">
<mat-dialog-content class="content">
  <div class="tech-operative-content2">
  <div class="divvarios pb20">{{ 'k002613' | translate }}</div>
  <div class="divvarios"><p [innerHTML]="'k002614' | translate"></p></div>
  <div class="tablapartialdeposit card-gray">
      <div class="nombre1 blue-dark">{{ 'k002616' | translate }}</div>
      <div class="copy1 blue2">
        <span
          class="blue2 pointer"
          [cdkCopyToClipboard]="bankData.bankAccount"
          #tooltip0="matTooltip"
          matTooltipPosition="above"
          matTooltip="{{ 'k001886' | translate }}"
          (mouseenter)="$event.stopImmediatePropagation()"
          (mouseleave)="$event.stopImmediatePropagation()"
          (click)="tooltip0.show()"
        >
        <fa-icon [icon]="['fal', 'copy']"> </fa-icon>
        {{ bankData.bankAccount }}
    </span>
      </div>

      <div class="nombre2 blue-dark"><span class="A">{{ 'k002618' | translate }}</span></div>
      <div class="copy2 blue2">
        <span
          class="pointer"
          [cdkCopyToClipboard]="bankData.beneficiaryName"
          #tooltip1="matTooltip"
          matTooltipPosition="above"
          matTooltip="{{ 'k001886' | translate }}"
          (mouseenter)="$event.stopImmediatePropagation()"
          (mouseleave)="$event.stopImmediatePropagation()"
          (click)="tooltip1.show()">
          <fa-icon [icon]="['fal', 'copy']"></fa-icon>
          {{ bankData.beneficiaryName }}
        </span>
      </div>
      <!--<div class="valor2 blue2">{{ bankData.beneficiaryName }}</div>-->

      <div class="nombre3 blue-dark">{{ 'k002619' | translate }}</div>
      <div class="copy3 blue2">
        <span
        class="pointer"
        [cdkCopyToClipboard]="bankData.swift"
        #tooltip2="matTooltip"
        matTooltipPosition="above"
        matTooltip="{{ 'k001886' | translate }}"
        (mouseenter)="$event.stopImmediatePropagation()"
        (mouseleave)="$event.stopImmediatePropagation()"
        (click)="tooltip2.show()">
        <fa-icon
        [icon]="['fal', 'copy']"
        >
        </fa-icon>
        {{ bankData.swift }}
        </span>
      </div>
      <!--<div class="valor3 blue2">{{ bankData.swift }}</div>-->

      <div class="nombre4 blue-dark"><span class="A">{{ 'k002620' | translate }}</span></div>
      <div class="copy4 blue2">
        <span
        [cdkCopyToClipboard]="bankData.bankName"
        #tooltip3="matTooltip"
        matTooltipPosition="above"
        matTooltip="{{ 'k001886' | translate }}"
        (mouseenter)="$event.stopImmediatePropagation()"
        (mouseleave)="$event.stopImmediatePropagation()"
        (click)="tooltip3.show()">
          <fa-icon
          [icon]="['fal', 'copy']">
          </fa-icon>
          {{ bankData.bankName }}
        </span>
      </div>
      <!--<div class="valor4 blue2">{{ bankData.bankName }}</div>-->

      <div class="nombre5 blue-dark">
        <span class="A">{{ 'k002621' | translate }}</span>
      </div>
      <div class="copy5 blue2">
      <span
        [cdkCopyToClipboard]="bankData.message"
        #tooltip4="matTooltip"
        matTooltipPosition="above"
        matTooltip="{{ 'k001886' | translate }}"
        (mouseenter)="$event.stopImmediatePropagation()"
        (mouseleave)="$event.stopImmediatePropagation()"
        (click)="tooltip4.show()">
        <fa-icon
        [icon]="['fal', 'copy']">
        </fa-icon>
        {{ bankData.message }}
      </span>
      </div>
      <!--<div class="valor5 blue2">{{ bankData.message }}</div>-->
  </div>
  <div class="divvarios" *ngIf="showButtons">{{ 'k002586' | translate }}</div>
  <div class="panelpartial" *ngIf="showButtons">
    <mat-expansion-panel  id="expansionnone" class="bg-light-grey"  (opened)="isOpen = true" (closed)="isOpen=false">
      <mat-expansion-panel-header>
        <mat-panel-title class="c11 pointer w-100 d-block">
          {{ 'k003000' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="divvarios">
        <span>{{ 'k002580' | translate }}</span>
      </div>
      <div  class="tech-popup-btns" mat-dialog-actions>
        <button  class="buttonPortal cancel" [mat-dialog-close]="true"><!--class="btn" -->
          {{ 'k002581' | translate }}
        </button>
        <button class="btnNuevo" mat-flat-button #buttonS color="primary" (click)="deletepartial()">
          {{ 'k002582' | translate }}
        </button>
      </div>
    </mat-expansion-panel>
  </div>
  </div>
</mat-dialog-content>
</ng-container>
